module.exports = "pegasus/assets/circleline-twitter-old.png";